import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Contacto.css';


import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faQuestionCircle,
  faCalendarAlt,
  faPhone,
  faMapMarkerAlt,
  faUsers
} from '@fortawesome/free-solid-svg-icons';

function ContactoAyuda() {
  return (
    <Container className="mt-5 contacto-ayuda">
      <h2 className="tituloAyuda mb-5 text-center">Ayuda y Contacto</h2>
      <Row className="mb-4">
        <Col md={6}>
          <FontAwesomeIcon icon={faUsers}  className="me-2 icono"  />
          <h4>Gestión de usuarios</h4>
          <p>
            Nuestra plataforma permite que los usuarios registrados puedan ver más detalles sobre futuras actividades,
            así como registrarse directamente en eventos o colonias.
          </p>
        </Col>
        <Col md={6}>
          <FontAwesomeIcon icon={faCalendarAlt} size="2x" className="me-2 icono" />
          <h4>Tipos de actividades</h4>
          <p>
            Disponemos de eventos especiales como Halloween, Navidad, además de las clásicas
            Colonias de verano. Todas están accesibles desde el panel de eventos.
          </p>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <FontAwesomeIcon icon={faQuestionCircle} size="2x" className="me-2 icono" />
          <h4>¿Cómo funciona la página?</h4>
          <p>
            Una vez registrado, puedes explorar los eventos disponibles, conocer los detalles, e inscribirte directamente
            desde tu cuenta de usuario.
          </p>
        </Col>
        <Col md={6}>
          <FontAwesomeIcon icon={faPhone} size="2x" className="me-2 icono" />
          <h4>¿Necesitas ayuda?</h4>
          <p>
            Si tienes dudas, puedes contactar con uno de nuestros monitores.
            <br />
            <strong>Teléfono:</strong> +34 123 456 789
            <br />
            <strong>Dirección:</strong> Calle de las Colonias, 42, Jaén
          </p>
        </Col>
      </Row>

      <Row>
        <Col className="text-center">
          <FontAwesomeIcon icon={faMapMarkerAlt} size="2x" className="me-2 icono" />
          <p>
            Estamos disponibles para ayudarte en todo momento durante el proceso de inscripción o participación en nuestras actividades.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default ContactoAyuda;
